export const SALARY_AWARDS_MIN_YEAR = 2026;
export const SALARY_AWARDS_MIN_MONTH = 4;

export function compareMonthYear(a, b) {
  return a.year * 100 + a.month - (b.year * 100 + b.month);
}

export function getSalaryAwardsMonthBounds() {
  const now = new Date();
  return {
    min: { year: SALARY_AWARDS_MIN_YEAR, month: SALARY_AWARDS_MIN_MONTH },
    max: { year: now.getFullYear(), month: now.getMonth() + 1 },
  };
}

export function clampToSalaryAwardsMonthRange(year, month) {
  const { min, max } = getSalaryAwardsMonthBounds();
  const value = { year: Number(year), month: Number(month) };
  if (compareMonthYear(value, min) < 0) return { ...min };
  if (compareMonthYear(value, max) > 0) return { ...max };
  return value;
}

export function getDefaultSalaryAwardsMonth() {
  const now = new Date();
  const clamped = clampToSalaryAwardsMonthRange(
    now.getFullYear(),
    now.getMonth() + 1
  );
  return {
    year: String(clamped.year),
    month: String(clamped.month).padStart(2, "0"),
  };
}
